export default {"src":"/_next/static/media/semiconductor.91b0945b.svg","height":160,"width":160};